<template>
  <v-container fluid class="px-0">
    <v-tabs v-model="tabs">
      <v-tab>
        DESGLOSE DE ENTREGAS
      </v-tab>
      <v-tab>
        OP's
      </v-tab>
      <v-tab>
        Direcciones
      </v-tab>
      <v-tab-item>
        <product-list-all :tab="tabs" @changeTab="calendarSelection" />
      </v-tab-item>
      <v-tab-item>
        <v-row justify="center" align="center">
          <v-col cols="12" xl="6" lg="6">
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="search" label="Buscar..." clearable>
            </v-text-field>
          </v-col>
          <v-col cols="12" xl="6" lg="6">
            <v-row class="d-flex justify-end align-center">
              <v-col cols="auto">
                <v-btn color="primary" @click="showNewOP = true">
                  <v-icon> mdi-package-variant-plus </v-icon>
                  Nueva OP
                </v-btn>
              </v-col>
              <!-- <v-col cols="auto">
                <v-btn color="primary" dark @click="showFiltersModal = true">
                  <v-icon>mdi-filter</v-icon>
                  Filtrar ops
                </v-btn>
              </v-col> -->
              <v-col cols="auto">
                <v-btn color="primary" @click="fetchData">
                  <v-icon>mdi-refresh</v-icon>
                  Recargar
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-data-table fixed-header height="calc(100vh - (400px))" :headers="headers" :items="ops"
              :items-per-page="10" no-data-text="No hay ops" loading-text="Cargando ops..." :page.sync="page"
              hide-default-footer :loading="fetchingData" :item-class="row_classes" @click:row="rowSelect">
              <template #[`item.createdAt`]="{ item }">
                <span>{{ dateFormat(item.createdAt) }}</span>
              </template>
              <template #[`item.productionState`]="{ item }">
                <span v-if="item.productionState">{{
                  dateFormat(item.productionState)
                  }}</span>
                <span v-else>0</span>
              </template>
              <template #[`item.address`]="{ item }">
                <span v-if="item.address">{{ item.address.name }}</span>
                <span v-else>-</span>
              </template>
              <template #[`item.order`]="{ item }">
                <v-menu :rounded="true" offset-y>
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn class="white--text" v-bind="attrs" v-on="on" text fab x-small>
                      <v-icon color="black"> mdi-dots-vertical </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="updateDeliveryOP(item)">
                      <v-list-item-title> Ver OP</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="handleViewDeliveries(item)">
                      <v-list-item-title> Ver entregas</v-list-item-title>
                    </v-list-item>
                    <!-- <v-list-item @click="updateOrder(item)">
                      <v-list-item-title>Agregar entrega </v-list-item-title>
                    </v-list-item> -->
                    <v-list-item @click="handleDeleteSelection(item)">
                      <v-list-item-title>Eliminar</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openCopyModal(item)">
                      <v-list-item-title>Copiar OP</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
            <v-pagination v-model="page" :length="numPages" total-visible="10" color="primary"></v-pagination>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <AddressList />
      </v-tab-item>
    </v-tabs>


    <NewOP v-model="showNewOP" @update="handleNewOPAdded()" v-if="showNewOP" />
    <AddDeliveryOP v-model="showAddDeliveryOP" @update="fetchData()" v-if="showAddDeliveryOP" />
    <UpdateDeliveryOP v-model="showUpdateDeliveryOP" @update="fetchData()" v-if="showUpdateDeliveryOP" />
    <FiltersModal v-model="showFiltersModal" @filter="filter" />
    <CopyOPModal v-if="copyOP" v-model="showConfirmationCopyOP" :copyOP="copyOP" @update="update"
      :title="`¿Estás seguro que quieres copiar la OP ${copyOP.serial}?`" />
    <DeliveriesModal v-model="showDeliveriesModal" v-if="showDeliveriesModal" @update="fetchData()" />
    <DeleteOrderModal v-model="showDeleteOrderModal" v-if="showDeleteOrderModal" @update="fetchData()" />
  </v-container>
</template>

<script>
// components
import NewOP from "@/components/dashboard/production-orders/modals/NewOP.vue";
import AddDeliveryOP from "@/components/dashboard/production-orders/modals/AddDeliveryOP.vue";
import UpdateDeliveryOP from "@/components/dashboard/production-orders/modals/UpdateDeliveryOP.vue";
import FiltersModal from "@/components/dashboard/production-orders/modals/FiltersModal.vue";
import CopyOPModal from "@/components/dashboard/production-orders/modals/CopyOPModal.vue";
import AddressList from "./components/AddressList.vue";
import DeliveriesModal from "./modals/DeliveriesModal.vue";
import DeleteOrderModal from "./modals/DeleteOrderModal.vue";
//vuex
import { mapActions, mapMutations, mapState } from "vuex";
//Libraries
import dayjs from "dayjs";
import ProductListAll from './components/ProductListAll.vue';
export default {
  components: {
    NewOP,
    AddDeliveryOP,
    FiltersModal,
    UpdateDeliveryOP,
    CopyOPModal,
    ProductListAll,
    AddressList,
    DeliveriesModal,
    DeleteOrderModal,
  },
  data: () => ({
    tabs: null,
    showConfirmationCopyOP: false,
    search: null,
    expanded: [],
    headers: [
      { text: "OP ID", align: "start", value: "serial", sortable: false },
      { text: "Cliente", align: "center", value: "client", sortable: false },
      {
        text: "Dirección",
        align: "center",
        value: "address",
        sortable: false,
      },
      {
        text: "Tipo de OP",
        align: "center",
        value: "saleType",
        sortable: false,
      },
      {
        text: "Etiqueta",
        align: "center",
        value: "label",
        sortable: false,
      },
      { text: "Fecha creación", value: "createdAt", sortable: false },
      { text: "Acciones", align: "center", value: "order", sortable: false },
    ],
    ops: [],
    page: 1,
    filters: null,
    fetchingData: false,
    showNewOP: false,
    showAddDeliveryOP: false,
    showFiltersModal: false,
    showUpdateDeliveryOP: false,
    numPages: 1,
    copyOP: null,
    showDeliveriesModal: false,
    showDeleteOrderModal: false,
  }),

  async created() {
    this.fetchData();
  },

  methods: {
    ...mapActions("order", ["getOrders", "createOPCopied"]),
    ...mapMutations("order", ["SET_ORDER_EVENTS", "SET_ORDER_TO_UPDATE"]),
    row_classes(value) {
      if (value.clicked) {
        return "custom-highlight-row";
      }
    },

    async fetchData() {
      this.showNewOP = false;
      this.showAddDeliveryOP = false;
      try {
        this.fetchingData = true;
        let response = await this.getOrders({
          page: this.page,
          search: this.search,
          filters: this.filters,
        });

        if (response) {
          if (!response.error) {
            this.ops = response.orders;
            // this.SET_ORDER_EVENTS(response.orders);
            this.numPages = response.pages;
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al cargar ordenes`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar ordenes`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar ordenes`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.fetchingData = false;
    },

    rowSelect(rowValue) {
      this.ops = this.ops.map((data) => {
        if (rowValue._id == data._id) {
          data.clicked = true;
        } else {
          data.clicked = false;
        }
        return data;
      });

      let opSelected = [rowValue];
      // this.SET_ORDER_EVENTS(opSelected);
      // this.SET_LOTE_SELECTED(rowValue);
    },
    dateFormat(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY - HH:mm")} hrs`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    dateFormatShort(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY")}`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    updateOrder(item) {
      this.SET_ORDER_TO_UPDATE(item);
      this.showAddDeliveryOP = true;
    },
    updateDeliveryOP(item) {
      this.SET_ORDER_TO_UPDATE(item);
      this.showUpdateDeliveryOP = true;
    },
    async filter(value) {
      this.filters = value;
      this.showFiltersModal = false;
      await this.fetchData();
    },
    openCopyModal(item) {
      this.copyOP = item;
      this.showConfirmationCopyOP = true;
    },
    async update() {
      this.copyOP = null;
      this.showConfirmationCopyOP = false;
      await this.fetchData();
    },
    handleViewDeliveries(item) {
      this.SET_ORDER_TO_UPDATE(item);
      this.showDeliveriesModal = true
    },
    handleDeleteSelection(item) {
      this.SET_ORDER_TO_UPDATE(item);
      this.showDeleteOrderModal = true
    },
    calendarSelection() {
      this.tabs = 0
    },
    async handleNewOPAdded(){
      await this.fetchData()
      this.showAddDeliveryOP = true
    }
  },
  watch: {
    async search() {
      this.page = 1;
      await this.fetchData();
    },
    async page() {
      await this.fetchData();
    },
    async tabs() {
      if (this.tabs == 1) {
        await this.fetchData();
      }
    }
  },
};
</script>
